import Model from './model';

export default class ProfileCategory extends Model {
  static NAME = 'profile_category';
  static COLLECTION_NAME = "profile_categories";
  static URL = '/api/v2/profile_categories';

  static DISPLAY_NAME = {
    finance: 'Finance',
    operations: 'Operations',
    management: 'Management',
    technology: 'Technology',
    marketing: 'Marketing',
  };

  displayName = () => {
    const name = this.name;
    return ProfileCategory.DISPLAY_NAME[name] || name;
  }
}
